"use client";

import { signIn } from "next-auth/react";

export default function LoginPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-surface-subtle">
      <div className="bg-surface p-8 rounded-lg shadow-md w-full max-w-md">
        <h1 className="text-2xl font-bold text-text text-center mb-6">
          루트인 요가 로그인
        </h1>

        <p className="text-text-muted text-center mb-6">
          네이버 계정으로 로그인하세요
        </p>

        <button
          onClick={() => signIn("naver", { callbackUrl: "/" })}
          className="w-full py-3 px-4 bg-[#03C75A] text-text-inverse font-semibold rounded-md hover:bg-[#02b350] transition flex items-center justify-center gap-2"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="20" height="20" fill="white" />
            <path
              d="M13.3333 10.8333L6.66667 2.5V10.8333H13.3333Z"
              fill="#03C75A"
            />
            <path
              d="M6.66667 9.16667L13.3333 17.5V9.16667H6.66667Z"
              fill="white"
            />
          </svg>
          네이버로 로그인
        </button>
      </div>
    </div>
  );
}
